(function(angular) {
	'use strict';

	angular.module('xpsui:filters', []);
}(angular));